/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';

import template from './target-super-summary.component.html';
import {ADN_TARGETING_TYPES} from './targeting-constants';
import {TargetingHelper} from './targeting-helper';
import {AngularModalService} from '../common/modal/angular-modal.service';
import {TargetSuperSummaryDetailModalComponent} from './target-super-summary-detail-modal.component';

export interface SuperSummaryTargetResult {
  size: number;
  key: string;
  negated?: boolean;
  targetingType: any;
}

@Component({
  standalone: false,
  selector: 'adn-target-super-summary',
  template
})
export class TargetSuperSummaryComponent implements OnChanges {
  @Input() targeting: any;
  @Input() obj: any;

  targetResults: SuperSummaryTargetResult[] = [];

  constructor(
    private readonly angularModalService: AngularModalService,
    private readonly destroyRef: DestroyRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.targeting) {
      this.refreshResults();
    }
  }

  expand(): void {
    void this.angularModalService.showAfterTick(TargetSuperSummaryDetailModalComponent, {
      class: 'modal-lg',
      // Avoid scrolling the long edit form when ngx-bootstrap focuses the modal host.
      focus: false,
      initialState: {
        targeting: this.targeting,
        obj: this.obj
      }
    }, this.destroyRef);
  }

  private refreshResults(): void {
    const results: SuperSummaryTargetResult[] = [];
    _.forEach(this.targeting || {}, (lValue: any, key: string) => {
      let size = 0;
      let resolvedKey = key;
      if (_.endsWith(key, 'Size') && _.isNumber(this.targeting[key])) {
        size = this.targeting[key];
        resolvedKey = key.slice(0, -4);
      } else {
        size = TargetingHelper.getSizeOfTargetingTypes(this.targeting[key], key);
      }
      const targetingType = _.find(ADN_TARGETING_TYPES, {targets: resolvedKey});
      if (size > 0 && targetingType) {
        results.push({
          size,
          key: resolvedKey,
          negated: !!lValue?.negated,
          targetingType
        });
      }
    });
    this.targetResults = results;
  }
}
